<template>
   <div class="category_wrapper">
       <div class="text-center logo_app2">
           <img :src="get_setting_app.logo" alt="logo">
           <!-- <img
                    src="@/assets/logo_smile.png"
                    alt="logo"
                > -->
       </div>
       <div class="container-fluid container-xl mt-5">
              <div class="row">
                <div class="col-xl-4 col-6"  v-for="category in getCate_list" :key="category.id">
                     <router-link uk-scrollspy="cls: uk-animation-slide-left; repeat: false; delay: 400;" class="box_cate_home" :to="{ path: `/meny/${category.url}`}" @click.native="go_to_category(category)">
                     <div class="new_cate_box">
                         <div class="img_cate">
                             <template v-if="category.icon">
                                 <img :src="category.icon" alt="">
                             </template>
                             <template v-else>
                                <img :src="get_setting_app.logo" alt="">
                             </template>
                         </div>
                         <div class="name_cate">
                              <span class="cate_tit">{{category.name}}</span>
                         </div>
                     </div>
                     </router-link>
                </div>
            </div>
       </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
export default {
   name:'homeApp',
   data(){
       return{
            colors:'',
       }
   },
    components:{},
   computed:{
       ...mapGetters({
            getCate_list:'getCate_list',
            get_default_cate:'get_default_cate',
            get_setting_app:'get_setting_app',
       })
   },
   methods:{
       ...mapActions({
       getCategoryMenu_Api:'getCategoryMenu_Api',
       change_category:'change_category'
   }),
   go_to_category(cate){
       let cate_obj = {
        'id':cate.id,
        'name':cate.name,
        'url':cate.url
      }
     this.change_category(cate_obj);
   }
   },
   mounted(){
       // get category from api
       console.log(this.colors);
       this.getCategoryMenu_Api();
   }
   
}
</script>


<style  scoped lang="scss">
.rel_index{
    position: relative;
    z-index: 3;
}
.logo_app2{
    img{
        width: 230px;
    }
}
.box_cate_home{
    display: block;
      border: 1px solid gainsboro;
    box-shadow: 0px 0px 4px #a7a7a7d9;
    background-color: white;
    position: relative;
    min-height: 150px;
    margin-top: 60px;
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
    border-radius: 28px;
    width: 96%;
    transition: 0.2s linear;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 20px;
    &:hover{
        transform: scale(1.06);
         border: 1px solid var(--active_color);
    box-shadow: 0px 0px 4px #a7a7a7d9;
    background-color: var(--active_color);
    }
    .img_cate{
        position: absolute;
        top: -85px;
        left: 0;
        right: 0;
        margin-left: auto;
        margin-right: auto;
        text-align: center;
        img{
             width: 260px;
            height: 160px;
            padding: 16px;
            object-fit: contain;
        }
    }
    .name_cate{
            padding-top: 90px;
    color: black;
    font-size: 26px;
    text-align: center;
    font-weight: 600;
    padding-bottom: 30px;
    }
}
.main_slider{
    margin-top: -80px;
}
    .uk-slideshow-items, .wrap_slider{
        video{
            width: 100%;
            height: 550px;
            object-fit: cover;
        }
        height: 670px !important;
          min-height: 670px !important;
    }

    .google_slider{
        display: flex;
        align-items: center;
        margin-top: 30px;
        margin-left: 0px;
        position: relative;
        .sub_title_1{
            position: absolute;
            top: -20px;
            left: 20px;
            color: var(--active_color);
            font-size: 16px;
            font-weight: 500;
        }
        img.apple{
            width: 162px;
            height: 78px;
            object-fit: contain;
            
        }
         img.google{
            width: 200px;
            
        }
    }
    .link_head{
    color: #fff;
    font-size: 16px;
    font-weight: 700;
    background-color: var(--active_color);
    border-radius: 4px;
    margin: 20px 0px 0px 0px;
    animation-delay: 1.9s;
    transition: 0.3s linear;
    display: inline-flex;
    align-items: center;
    border: 1px solid var(--active_color);
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;
    .ico_l{
            padding: 6px 12px;
             border-right: 1px solid transparent;
             font-family: 'Sriracha', cursive !important;
    }
    .ico_r{
        background-color: #EAEAEA;
            padding: 6px 10px;
            
        img{
    width: 25px;
    object-fit: contain;
        }
    }
    &:hover{
         transition: 0.3s linear;
        //  border: 1px solid var(--active_color2);
        color: var(--active_color) !important;
        background-color: #EAEAEA;
       .ico_l{
            border-right: 1px solid var(--active_color);
       }
    }
}
.wrap_slider {
    .row:first-child{
        position: relative;
        align-items: center;
        align-content: center;
        height: 100%;
        z-index: 2;
        padding-top: 0px;
           &::after{
        content: '';
        // background-image: url('~@/assets/woo1.png');
       position: absolute;
    right: 0;
    height: 90%;
    width: 100%;
    top: 0%;
    z-index: 2;
    background-size: contain;
    background-position: right;
    background-repeat: no-repeat;
    }
    }
.main_img{
    z-index:4;
    position:relative;
}
.itlay_bg{
    position: absolute;
    height: 100%;
    z-index: 0;
    object-fit: cover;
    top: 0;
    width: 100%;
    left: 0;
    object-position: center;
}
    .left_img_sm{
        text-align: center;
        position: relative;
        img{
            width: 25vw;
    -webkit-animation-duration: 1s;
    animation-duration: 1s;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
    animation-name: fadeInLeft;
    animation-delay: 1s;
        }

        @keyframes fadeInLeft {
            0% {
                opacity: 0;
                -webkit-transform: translate3d(-100%, 0, 0);
                transform: translate3d(-100%, 0, 0);
            }
        100% {
            opacity: 1;
            -webkit-transform: translate3d(0, 0, 0);
            transform: translate3d(0, 0, 0);
        }
        }
        // 
     .ani1{
     position: absolute;
    width: 200px;
    z-index: 0;
    left: 16%;
    top: 0%;
    }
     .ani2{
       position: absolute;
    width: 120px;
    bottom: -1%;
    left: 24%;
    z-index: 0;
    }
    .ani3{
         position: absolute;
    width: 150px;
    right: 20%;
    bottom: 0%;
    z-index: 4;
    }
    .ani4{
      position: absolute;
    width: 70px;
    bottom: -12%;
    left: 39%;
    z-index: 4;
    }
     .ani5{
        position: absolute;
    width: 120px;
    top: 20%;
    right: 10%;
    z-index: 4;
    }
     .ani6{
     position: absolute;
    width: 180px;
    top: 0%;
    left: 2%;
    z-index: 4;
    }
    .ani_img1{
    animation-duration: 2s;
    animation-fill-mode: both;
    animation-name: bounceInDown;
    animation-delay: 1.5s;
        }
        .ani_img2{
    animation-duration: 2s;
    animation-fill-mode: both;
    animation-name: bounceInDown;
    animation-delay: 1s;
        }
         .ani_img3{
    animation-duration: 2s;
    animation-fill-mode: both;
    animation-name: bounceInDown;
    animation-delay: 2.2s;
        }
         .ani_img4{
    animation-duration: 2.9s;
    animation-fill-mode: both;
    animation-name: bounceInDown;
    animation-delay: 1.5s;
        }
         .ani_img5{
    animation-duration: 2s;
    animation-fill-mode: both;
    animation-name: bounceInDown;
    animation-delay: 1.5s;
        }
          .ani_img6{
    animation-duration: 2s;
    animation-fill-mode: both;
    animation-name: bounceInDown;
    animation-delay: 1.9s;
        }

        // animation keyframe
@keyframes bounceInDown {
 0%, 60%, 75%, 90%, 100% {
    -webkit-animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
}

0% {
    opacity: 0;
    -webkit-transform: translate3d(0, -3000px, 0);
    transform: translate3d(0, -3000px, 0);
}
60% {
    opacity: 1;
    -webkit-transform: translate3d(0, 25px, 0);
    transform: translate3d(0, 25px, 0);
}
75% {
    -webkit-transform: translate3d(0, -10px, 0);
    transform: translate3d(0, -10px, 0);
}
90% {
    -webkit-transform: translate3d(0, 5px, 0);
    transform: translate3d(0, 5px, 0);
}
100% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
}   
}

@keyframes fadeInRight {
    0% {
    opacity: 0;
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0);
}

100% {
    opacity: 1;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
}
}
        // end 
    }
    .wrap_linkss{
        text-align: right;
    }
    .right_text{
         text-align: left;
          padding-left: 40px;
        h1{
            color: var(--active_color2);
            //  text-shadow: 5px 2px 5px #1e1e1e;
            font-size: 3rem;
            font-weight: 700;
    animation-duration: .5s;
    animation-fill-mode: both;
    animation-name: fadeInRight;
    animation-delay: 0.5s;
    font-family: 'Sriracha', cursive !important;

        }
        h1.color_h1{
            font-family: 'Sriracha', cursive !important;
        }
        p{
            font-size: 1.2rem;
            font-weight: 500;
            padding-left: 6px;
            // text-shadow: 5px 2px 5px #1e1e1e;
             color: black;
             font-family: 'Sriracha', cursive !important;
            // 
            animation-duration: .5s;
            animation-fill-mode: both;
            animation-name: fadeInRight;
            animation-delay: 0.9s;
        }
    }
}
// 
.category_wrapper{
       padding-top: 60px;
    margin-bottom: 50px;
    position: relative;
    h1{
        font-size: 32px;
        font-weight: 600;
        color: var(--active_color);
        margin-bottom: 40px;
    }
  
}

.ads_qhw{
    width: 100%;
    height: 180px;
    background-color: #312F30;
    display: flex;
    align-content: center;
    position: relative;
    justify-content: space-around;
    margin-top: 100px;
    // overflow-x: hidden;
    .left_ads{
        display: flex;
    align-content: center;
    position: relative;
    }
    .apps{
        display: flex;
        flex-direction:column;
        padding-top: 10px;
        img.apple{
           width: 240px;
            height: 60px;
            object-fit: contain;
        }
         img.google{
            width: 240px;
            height: 80px;
            object-fit: contain;
        }
    }
    .girl{
        img{
           position: absolute;
            width: 500px;
            height: 240px;
            z-index: 99;
            object-fit: contain;
            bottom: -2px;
            z-index: 0;
        }
    }
    .center_text{
        padding-top: 30px;
        strong{   
        display: block;
        font-size: 44px;
        color: #fff;
        }
        span{
            display: block;
            font-size: 20px;
            font-weight: 500;
           color: #fff;
        }
    }
    .right_food{
        img{
             width: 300px;
            height: 322px;
            -o-object-fit: contain;
            object-fit: contain;
            position: absolute;
            right: 24px;
            bottom: -28px;;
        }
    }
}
@media(min-width:1700px){
  .uk-slideshow-items, .wrap_slider{
        video{
            // width: 100% !important;
            height: 62vh !important;
            object-fit: cover;
        }
        height: 62vh !important;
          min-height: 62vh !important;
        //   width: 100% !important;
        //   img{
        //       height:62vh !important;
        //     //   width: 100% !important;
        //       object-fit: cover;
        //   }
    }   
}
@media(max-width:1300px){
    .ads_qhw{
    justify-content: space-between;
    .center_text{
        flex: 0 0 400px;
    }
}

 .wrap_slider .left_img_sm {

      .ani1{
     position: absolute;
    width: 200px;
    z-index: 0;
    left: 12%;
    top: 0%;
    }
     .ani2{
       position: absolute;
    width: 120px;
    bottom: -1%;
        left: 18%;
    z-index: 0;
    }
    .ani3{
         position: absolute;
    width: 150px;
      right: 12%;
    bottom: 0%;
    z-index: 4;
    }
 }
}
@media(max-width:1199px){
    // 
    .ads_qhw{
    .center_text{
           margin-left: 20px;
    }
    .center_text strong{
    display: block;
    font-size: 28px;
    }
     .center_text span{
    display: block;
    font-size: 16px;
    font-weight: 600;
    }
   .right_food img {
    width: 300px;
    height: 310px;
        }
    .girl img {
    margin-left: -40px;
        }
    }

   .wrap_slider .right_text{
       h1{
           font-size: 2.4rem;
       }
       p{
        font-size: 1.2rem;
       }
   }
   .link_head{
       font-size: 14px;
   }
   .wrap_slider .left_img_sm {

      .ani1{
     position: absolute;
    width: 200px;
    z-index: 0;
    left: 12%;
    top: 0%;
    }
     .ani2{
       position: absolute;
    width: 120px;
    bottom: -1%;
        left: 18%;
    z-index: 0;
    }
    .ani3{
         position: absolute;
    width: 150px;
      right: 12%;
    bottom: 0%;
    z-index: 4;
    }
    .ani4{
      position: absolute;
    width: 50px;
    bottom: -12%;
    left: 39%;
    z-index: 4;
    }
     .ani5{
        position: absolute;
    width: 140px;
    top: 20%;
    right: 2%;
    z-index: 4;
    }
     .ani6{
      position: absolute;
    width: 150px;
    top: -16%;
    left: 0%;
    z-index: 4;
    }
}
}

@media(max-width:992px){
    // 
    .center_text {
    flex: 0 0 40%;  
    }
    .wrap_slider .row:first-child::after {
    content: '';
    position: absolute;
    right: 0;
    height: 100%;
    width: 100%;
    top: 0%;
    z-index: 2;
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
}

     .right_food {
         display: none;
        }
    // 

      .wrap_slider .right_text{
       h1{
           font-size: 2rem;
       }
       p{
        font-size: 0.9rem;
       }
   }
   .wrap_slider .left_img_sm{
      .ani1{
     position: absolute;
    width: 200px;
    z-index: 0;
       left: 8%;
    top: 0%;
    }
     .ani2{
       position: absolute;
    width: 120px;
    bottom: -1%;
     left: 14%;
    z-index: 0;
    }
    .ani3{
      position: absolute;
    width: 130px;
    right: 14%;
    bottom: 0%;
    z-index: 4;
    }
 
    .ani4{
      position: absolute;
    width: 50px;
    bottom: -12%;
    left: 39%;
    z-index: 4;
    }
     .ani5{
       position: absolute;
    width: 100px;
    top: 22%;
    right: 3%;
    z-index: 4;
    }
     .ani6{
  position: absolute;
    width: 150px;
    top: -16%;
    left: -4%;
    z-index: 4;
    }
  
  }
  
}
@media(max-width:767px){
    .category_wrapper{
       padding-top: 30px;
    margin-bottom: 50px;
    position: relative;
    }
        .small_sc{
        text-align: center;
        padding-top: 40px;
        .left_img_sm{
            position: relative;
            display: inline-block;
        }
    }
.box_cate_home{
min-height: 100px;
.img_cate{
           position: absolute;
    top: -58px;
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
        img{
    width: 155px !important;
    height: 125px !important;
    padding: 20px;
    
        }
    }
.name_cate {
    padding-top: 60px;
    font-size: 15px;
}
}
      
     .center_text {
         display: none;
    }
    .ads_qhw{
        justify-content: center;
        .left_ads{
            margin-left: -190px;
        }
    }
    .google_slider img.apple {
    width: 122px;
    height: 60px;
    -o-object-fit: contain;
    object-fit: contain;
}
.google_slider img.google{
    width: 150px;
    object-fit: contain;
}
 
.ads_qhw .girl img {
    position: absolute;
    width: 185px;
    height: 340px;
    z-index: 99;
    -o-object-fit: contain;
    object-fit: contain;
    bottom: -80px;
    z-index: 0;
}
.ads_qhw .girl img{
    margin-left: -30px;
}
// 


    .uk-slideshow-items, .wrap_slider{
        video{
            width: 100%;
            height: 550.375px;
            object-fit: cover;
        }
        height:550.375px !important;
          min-height: 550.375px !important;
    }
    .wrap_linkss{
        padding-right: 30px;
        a{
            font-size: 15px;
        }
    }
    .wrap_slider{
        .right_text{
    text-align: center;
        padding-top: 100px;
    padding-left: 4px;
    padding-right: 4px;
    }
    }
    .google_slider{
    margin-top: 14px;
    justify-content: center;
    }
    .wrap_slider .right_text p {
    text-shadow: 0px 1px 3px #484848;
    color: #fff;
    }
    .wrap_slider .left_img_sm img{
        width: 25vw;    
    }
.category_wrapper .remak_category{
    width: 96%;
}
.wrap_slider .row:first-child{
    padding-top: 0px;
}
.wrap_slider .left_img_sm{
   .ani1{
      position: absolute;
    width: 120px;
    left: -25%;
    bottom: 0;
    z-index: 0;
    }
     .ani2{
    position: absolute;
    width: 80px;
    bottom: -6%;
    z-index: 0;
    left: -20%;
    }
    .ani3{
       position: absolute;
    width: 100px;
    right: -30%;
    bottom: 0;
    z-index: 4;
    }
    .ani4{
       position: absolute;
    width: 40px;
    bottom: -19%;
    left: 39%;
    z-index: 4;
    }
     .ani5{
         position: absolute;
    width: 80px;
    top: 36%;
    right: -38%;
    z-index: 4;
    }
     .ani6{
    position: absolute;
    width: 120px;
    top: -10%;
    left: -57%;
    z-index: 4;
    }
  
  }
 
    .wrap_slider .wrap_linkss{
        text-align: center !important; 
        a{
            font-size: 13px !important;
        }
    }
}

@media(max-width:550px){
    .wrap_slider{
    .left_img_sm img {
    width: 39vw;
}
 .right_text h1 {
    font-size: 1.3rem;
}
.right_text p{
    font-size: 0.7rem;
}
    }

    .wrap_slider .row:first-child {
    position: relative;
    padding-top: 0px !important;
}
}

</style>

